import React, { useState } from 'react';
import { TextField, Button, FormHelperText, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * 이메일 로그인/회원가입 폼 컴포넌트
 */
const EmailLoginForm = ({
  isSignup,
  email,
  password,
  confirmPassword,
  emailError,
  passwordError,
  authError,
  localError,
  handleEmailChange,
  handlePasswordChange,
  handleConfirmPasswordChange,
  handleEmailSubmit,
  setLocalError
}) => {
  const { t } = useTranslation();
  // const [localError, setLocalError] = useState(''); // 이제 prop으로 받음

  return (
    <form onSubmit={handleEmailSubmit}>
      <TextField
        fullWidth
        label={t('auth.email')}
        type="email"
        value={email}
        onChange={handleEmailChange}
        margin="normal"
        required
        error={!!emailError}
        helperText={emailError}
      />
      <TextField
        fullWidth
        label={t('auth.password')}
        type="password"
        value={password}
        onChange={handlePasswordChange}
        margin="normal"
        required
        error={!!passwordError}
      />
      {isSignup && (
        <>
          <FormHelperText error={!!passwordError} sx={{ ml: 1.5, whiteSpace: 'pre-line' }}>
            {passwordError || t('auth.passwordRequirements')}
          </FormHelperText>
          <TextField
            fullWidth
            label={t('auth.confirmPassword')}
            type="password"
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            margin="normal"
            required
            error={!!passwordError && password === confirmPassword}
            helperText={password !== confirmPassword ? t('auth.passwordMismatch') : ''}
          />
        </>
      )}
      <Button
        fullWidth
        variant="contained"
        type="submit"
        sx={{ mt: 2 }}
      >
        {isSignup ? t('auth.signupButton') : t('auth.loginButton')}
      </Button>
      
      {/* 로그인 에러 메시지 표시 - 조건 단순화 */}
      {(authError || localError) && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {authError || localError}
        </Alert>
      )}
      
      
    </form>
  );
};

export default EmailLoginForm; 